export function loadSuccess(instituicao) {
  return {
    type: '@instituicao/LOAD_SUCCESS',
    payload: { instituicao },
  };
}
